import { t } from 'i18next';

// HN returns components as UPPER_SNAKE_CASE constants (e.g. "EXTENDED_ADDRESS"); each
// caller's `componentLabels` maps those to its own (translated) UI vocabulary.
type ValidationStatusForMessage = {
  kind: 'incomplete' | 'invalid';
  errors: { path?: (string | null)[] | null }[];
};

export function formatComponentMessage(
  status: ValidationStatusForMessage,
  componentLabels: Record<string, string>
): string {
  const components = status.errors.map((e) => e.path?.[0]).filter((c): c is string => !!c);
  const labels = components.map((c) => componentLabels[c] ?? c);
  if (labels.length === 0) {
    return t('addressValidationGenericError');
  }
  const isPlural = labels.length > 1;
  const prefix =
    status.kind === 'incomplete'
      ? t(isPlural ? 'addressValidationMissingComponents' : 'addressValidationMissingComponent')
      : t(isPlural ? 'addressValidationInvalidComponents' : 'addressValidationInvalidComponent');
  return `${prefix} ${labels.join(', ')}`;
}
